import Form from 'antd/lib/form';
import * as React from 'react';
import { useState, useContext } from 'react';
import { Modal, Select } from 'antd';
import { ConfirmModalRejectPrePrecatorio } from './ConfirmModalRejectPrePrecatorio';
import { ServiceContext } from 'src/services/provider/Service.provider';
import { IPreprecatorioRejection } from 'src/services/interfaces/IPreprecatorioRejection';
import { PrePrecatorioRejectionTypeEnum, PrePrecatorioRejectionTypeCategoryLabel } from 'src/services/Enum/PrePrecatorioRejectionTypeEnum';
import { ShowNotification } from 'src/components/common/ShowNotification/ShowNotification';
import { PbrSelect } from 'src/components/common/PbrSelect/PbrSelect';

interface IRejectPrePrecatorioButtonProps {
    idPrePrecatorio: number;
    setLoading?: React.Dispatch<React.SetStateAction<boolean>>;
    className?: string;
    style?: React.CSSProperties;
    onReject?: () => void;
    title: string;
}

export const RejectPrePrecatorioButton: React.FC<IRejectPrePrecatorioButtonProps> = ({
    idPrePrecatorio,
    setLoading,
    className,
    style,
    onReject,
    title
}) => {

    const [showModal, setShowModal] = useState(false);
    const [isRequesting, setIsRequesting] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [reason, setReason] = useState<string>("");
    const [prePrecatorioRejectionType, setPrePrecatorioRejectionType] = useState<PrePrecatorioRejectionTypeEnum>(PrePrecatorioRejectionTypeEnum.COMMERCIAL_REASONS);

    const { prePrecatorioService } = useContext(ServiceContext);

    function reject() {
        setLoading(true);
        if (!isRequesting) {
            const request: IPreprecatorioRejection = {
                idPrePrecatorio,
                reason,
                type: prePrecatorioRejectionType
            }
            prePrecatorioService
                .rejectQuote(request)
                .then(() => {
                    ShowNotification.Success("Sucesso!", "Cotação Rejeitado");
                    onReject?.()
                })
                .catch(error => {
                    ShowNotification.Error("Erro ao rejeitar a Cotação!", "Tente novamente");
                })
                .finally(() => {
                    setModalLoading(false);
                    setLoading(false);
                });
        }
    }

    return (
        <>
            <button
                onClick={() => setShowModal(true)}
                className={`reject change-trade-phase btn ${className ?? ""}`}
                style={style}
            >
                <span>{"Rejeitar"}</span>
            </button>
            <Modal
                className="modal-mid"
                title={title}
                width={"80%"}
                visible={showModal}
                onOk={reject}
                onCancel={() => {
                    setIsRequesting(false);
                    setShowModal(false);
                }}
            >
                <Form>
                    <ConfirmModalRejectPrePrecatorio
                        modalLoading={modalLoading}
                        onReasonChange={setReason}
                        reasonPlaceholder={"Comentário adicional, Informe detalhes adicionais"}
                    />
                </Form>
                <PbrSelect
                    name="rejectionCategory"
                    size="large"
                    formItemProps={{ label: "Selecione a categoria da rejeição" }}
                    showSearch
                    value={prePrecatorioRejectionType}
                    onChange={e => setPrePrecatorioRejectionType(e as PrePrecatorioRejectionTypeEnum)}
                    placeholder="Categoria da rejeição"
                    rules={[{ required: true, message: "Informe a categoria da rejeição" }]}
                >
                    <Select.Option key={"none"} value="">
                        Selecione a categoria da rejeição
                    </Select.Option>
                    {Object.keys(PrePrecatorioRejectionTypeEnum).map(value => (
                        <Select.Option key={value} value={value}>
                            {PrePrecatorioRejectionTypeCategoryLabel.get(PrePrecatorioRejectionTypeEnum[value])}
                        </Select.Option>
                    ))}
                </PbrSelect>
            </Modal>
        </>
    );
}


// WEBPACK FOOTER //
// ./src/components/Refatoracao/RejectPrePrecatorio/RejectPrePrecatorioButton.tsx